import { render, staticRenderFns } from "./costAdd.vue?vue&type=template&id=5186222c&scoped=true&"
import script from "./costAdd.vue?vue&type=script&lang=js&"
export * from "./costAdd.vue?vue&type=script&lang=js&"
import style0 from "./costAdd.vue?vue&type=style&index=0&id=5186222c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5186222c",
  null
  
)

export default component.exports